import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { theme } from '../../constants';

function Iframe({ title, src }) {
  return (
    <iframe
      src={src}
      width={theme.uiFrameWidth}
      height={theme.uiFrameHeight}
      allowFullScreen
      allow="autoplay *; fullscreen *; encrypted-media *"
      frameBorder="0"
      title={title}
      css={styles.iframe}
    />
  );
}

const styles = {
  iframe: css`
    width: 100%;
    inline-size: 100%;
    block-size: 100.5%;
  `,
};

Iframe.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string,
};

export default Iframe;
